export const state = () => ({
  interacted: false,
  viewConfigure: false,
  conversionTracked: false
})

export const mutations = {
  SET_FILTERS_INTERACTED (state, val) { state.interacted = !!val },
  SET_VIEW_CONFIGURE (state, val) { state.viewConfigure = !!val },
  SET_CONVERSION_TRACKED (state, val) { state.conversionTracked = !!val },
  RESET_SESSION (state) {
    state.interacted = false
    state.viewConfigure = false
    state.conversionTracked = false
  }
}

export const actions = {
  SET_FILTERS_INTERACTED ({ commit }, val) { commit('SET_FILTERS_INTERACTED', val) },
  SET_VIEW_CONFIGURE ({ commit }, val) { commit('SET_VIEW_CONFIGURE', val) },
  SET_CONVERSION_TRACKED ({ commit }, val) { commit('SET_CONVERSION_TRACKED', val) },
  RESET_SESSION ({ commit }) { commit('RESET_SESSION') }
}

export const getters = {
  getFiltersInteracted: s => s.interacted,
  getViewConfigure: s => s.viewConfigure,
  getConversionTracked: s => s.conversionTracked
}
